import { render, staticRenderFns } from "./IconRice.vue?vue&type=template&id=206cbfcc&scoped=true&lang=pug&"
import script from "./IconRice.vue?vue&type=script&lang=js&"
export * from "./IconRice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206cbfcc",
  null
  
)

export default component.exports